/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Параметры поиска продуктов лояльности.
 */
export interface SearchParamsForLoyalty { 
    /**
     * Наименование продукта.
     */
    name?: string;
    /**
     * Список ID категорий.
     */
    categoryIds?: Array<string>;
    /**
     * Город для поиска
     */
    cityId?: number;
    /**
     * начало выборки (0 по-умолчанию)
     */
    start?: number;
    /**
     * кол-во (1000 по-умолчанию)
     */
    top?: number;
}

